/**
 * @author Ivan Toth.
 */
var FileUploadController = (function () {
    function FileUploadController($state, $scope, socket, topic, env, settings, notify) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.settings = settings;
        this.notify = notify;
        this.title = 'Eligibility';
        this.lockEnabled = false;
        this.section = 'eligibility';
        this.comp = 'files$eligibility';
        this.updateArray = ['files$eligibility'];
        this.showAttachment = false;
        this.submitting = true;
        this.sources = {};
        this.fileUploaded = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    FileUploadController.prototype.showHide = function () {
        this.showAttachment = this.showAttachment ? false : true;
    };
    FileUploadController.prototype.decode = function (file) {
        return decodeURIComponent(file); //Probably not necessary anymore since names are not being stored encoded
    };
    // Prepares the files for file upload
    FileUploadController.prototype.uploadFiles = function (files) {
        this.fileNames = [];
        var fileContent = files;
        // If some files submitted perform the update
        if (fileContent.length > 0) {
            var i = 0;
            for (var _i = 0, fileContent_1 = fileContent; _i < fileContent_1.length; _i++) {
                var file = fileContent_1[_i];
                console.info('$detail.file.upload (uploadFiles) => file before update: ' + file.name);
                this.fileNames[i] = { name: file.name, type: file.type, comment: '' };
                i++;
            }
            this.fileUploaded = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'uploadFile',
                    script: 'config/config',
                    data: { files: this.fileNames, id: this.topic.topic._id, type: this.section },
                    files: this.sources,
                    bID: this.topic.topicBrowserID,
                    token: this.env.user.token
                }
            });
        }
        this.edit.editMode = this.topic.cancelEdit(this.comp);
    };
    FileUploadController.prototype.downloadAttachment = function (name) {
        console.info('$detail.file.upload (downloadAttachment) downloaded attachment');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadAttachment',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.topic._id,
                    name: name
                }
            }
        });
    };
    FileUploadController.prototype.showUserData = function (file, visible) {
        file.visible = visible;
    };
    FileUploadController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    FileUploadController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                this.topic.sendForUpdateFiles(this.comp, false);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPartFiles(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    FileUploadController.prototype.commentChange = function (fileName) {
        angular.forEach(this.topic.temp.files, function (file) {
            if (file.name === fileName) {
                file.modified = true;
            }
        });
    };
    FileUploadController.$inject = ['$state', '$scope', 'socket', 'topic', 'env', 'settings', 'notify'];
    return FileUploadController;
}());
var FileUploadComponent = (function () {
    function FileUploadComponent() {
        this.templateUrl = 'detail-file-upload.html';
        this.controllerAs = 'vm';
        this.controller = FileUploadController;
    }
    return FileUploadComponent;
}());
angular
    .module('application')
    .component('fileUploadSection', new FileUploadComponent());

//# sourceMappingURL=detail.file.upload.js.map
